import { getUrl } from '@fortem-monorepo/js-utilities';
import { createNavigation } from '../navigation';
import { useUserContext } from '../providers';
export const createSpaSetup = (options) => {
    const navigation = createNavigation();
    return {
        ...navigation,
        useUserContext: (useUserContext),
        getUrl: (getUrl),
    };
};
